import {
  REMOVE_API_BOOKING_FROM_SERVICE,
  REMOVE_API_BOOKING_FROM_SERVICE_SUCCESS,
  REMOVE_API_BOOKING_FROM_SERVICE_FAILED,
} from "../types"

const initialState = {
  loading: false,
  message: null,
  error: false,
  success: false,
  serviceId: null,
  bookingId: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case REMOVE_API_BOOKING_FROM_SERVICE:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: null,
        serviceId: action.payload.serviceId,
        bookingId: action.payload.bookingId,
      }
    case REMOVE_API_BOOKING_FROM_SERVICE_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload.message,
        serviceId: action.payload.serviceId,
        bookingId: action.payload.bookingId,
      }
    case REMOVE_API_BOOKING_FROM_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        message: null,
        serviceId: action.payload.serviceId,
        bookingId: action.payload.bookingId,
      }
    default:
      return state
  }
}
